
import TextInput from "./TextInput";

export default function EmailInput(args) {

    const newArgs = {...args};
    newArgs.type  = "email";

    return <TextInput {...newArgs}/>

}